package gr.tech.GRAttestation.components.modals

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.css.maxWidth
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.*

@Composable
fun ConfirmModal(
    message: String,
    confirmText: String = "Confirm",
    cancelText: String = "Cancel",
    onConfirm: () -> Unit,
    onClose: () -> Unit,
) {
    Div(attrs = Modifier
        .classNames("card", "d-flex", "flex-column")
        .maxWidth(480.px)
        .fillMaxWidth(90.percent)
        .toAttrs {
            onClick { it.stopPropagation() }
        }
    ) {
        // Header
        Div(attrs = Modifier.classNames("d-flex", "flex-row", "justify-content-between", "p-3", "pb-3").toAttrs()) {
            H5(Modifier.classNames("fw-bold", "m-0").toAttrs()) {
                Text("Confirm")
            }

            Button(Modifier.classNames("btn-close").toAttrs {
                onClick { onClose() }
            })
        }

        // Body
        Div(attrs = Modifier.classNames("px-3", "pb-3").toAttrs()) {
            P(attrs = Modifier.classNames("text-secondary", "mb-0").toAttrs()) {
                Text(message)
            }
        }

        // Footer
        Div(attrs = Modifier.classNames("d-flex", "flex-row", "gap-2", "justify-content-start", "align-items-center", "px-3", "pb-3", "mt-2").toAttrs()) {
            Button(
                attrs = Modifier.classNames("btn", "btn-secondary").toAttrs {
                    onClick { onClose() }
                }
            ) {
                Text(cancelText)
            }

            Spacer()

            Button(
                attrs = Modifier.classNames("btn", "btn-danger").toAttrs {
                    onClick { onConfirm() }
                }
            ) {
                Text(confirmText)
            }
        }
    }
}
